<script lang="ts">
	import type { ClassValue, HTMLAttributes } from 'svelte/elements';

	interface Props extends HTMLAttributes<HTMLTableSectionElement> {
		headClass?: ClassValue;
		rowClass?: ClassValue;
		columns: {
			label: string;
			isSrOnly?: boolean;
			class?: ClassValue;
		}[];
	}

	const { columns, headClass, rowClass }: Props = $props();
</script>

<thead class={['max-md:hidden', headClass]}>
	<tr class={['font-400 font-size-3.5 line-height-4 uppercase text-coloredneutral-softest', rowClass]}>
		{#each columns as column (column.label)}
			<th class={['pb-2.5', column?.class]}>
				{#if column.isSrOnly}
					<span class="sr-only">{column.label}</span>
				{:else}
					{column.label}
				{/if}
			</th>
		{/each}
	</tr>
</thead>
